import React from "react";
import "./Green_Outline_Btn.css";
import { Button } from "react-bootstrap";

function Green_Outline_Btn({btnText,onClick}) {
  return (
    <>
      <section className="Green_Outline_Btn_holder">
        <Button className="Green_Outline_Btn" onClick={onClick}>{btnText}</Button>
      </section>
    </>
  );
}

export default Green_Outline_Btn;
